import contingents from '@/constants/contingents'

export const bidTransformer = (bid) => {
    return {
        ...bid,
        costDetails: bid.bidContingents.map(contingent => {
            return {
                label: contingents[contingent.contingentId],
                amount: contingent.percentage,
                rate: '%',
            }
        })
    }
}